import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './serviceWorkerRegistration';

if (typeof window !== 'undefined') {
  const { protocol, hostname, href } = window.location;
  if (hostname === 'beborne.com' && protocol === 'http:') {
    window.location.replace(href.replace(/^http:/, 'https:'));
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// The public showcase must not remove an operator's offline cache or worker.
if (!/^\/(?:orgasmeat|demo)(?:\/|$)/i.test(window.location.pathname)) registerServiceWorker();
